/**
 * 需求 R129（PM 2026-08-21 留言拍板）：產品「必填欄位」的唯一定義（前端）。
 *
 * 本檔是 src/server/utils/productRequiredFields.js 的鏡像：CRA 無法直接 require 後端的 CJS 檔，
 * 因此兩邊各留一份，並由 tests/productRequiredFields.fixture.js 斷言兩份的
 * 欄位 key／label／kind 完全一致——改一邊沒改另一邊，fixture 會紅。
 *
 * PM 拍板：
 *   Q1=C 必填＝產品名稱(中文)／規格／箱入數／保存期限／淨重／毛重／材積（共 7 個）
 *   Q2=A 材積以 volumeCbm > 0 判定（不管 volumeMethod 是自動計算／廠商提供／預估值）
 *   Q3=A 只有空白算未填，輸入 0 算有填
 *   Q4=B 不用 alert，改欄位級紅框＋欄位下方紅字＋自動跳到第一個
 *   Q5=A 只跳第一個，修好後再按儲存跳下一個
 *
 * 陣列順序＝畫面由上而下的顯示順序（AC11），「第一個未填欄位」即依此順序取第一筆。
 */

export const PRODUCT_REQUIRED_FIELDS = [
  { key: 'productName', label: '產品名稱 (中文)', kind: 'text' },
  { key: 'spec', label: '規格', kind: 'text' },
  { key: 'pcsPerBox', label: '箱入數', kind: 'number' },
  { key: 'shelfLife', label: '保存期限', kind: 'text' },
  { key: 'netWeight', label: '淨重 (kg)', kind: 'number' },
  { key: 'grossWeight', label: '毛重 (kg)', kind: 'number' },
  { key: 'volumeCbm', label: '材積', kind: 'volume' },
];

export const PRODUCT_REQUIRED_KEYS = PRODUCT_REQUIRED_FIELDS.map((f) => f.key);

// 空白（null / undefined / 只有空白字元）才算未填；'0' 與 0 都算有填（Q3=A）。
export const isBlankValue = (value) => value === null || value === undefined || String(value).trim() === '';

export const isRequiredFieldFilled = (key, value) => {
  const field = PRODUCT_REQUIRED_FIELDS.find((f) => f.key === key);
  if (!field) return true;
  if (field.kind === 'volume') {
    const n = parseFloat(value);
    return Number.isFinite(n) && n > 0;
  }
  return !isBlankValue(value);
};

/** 回傳未填的必填欄位（依畫面順序）；options.onlyKeys 可限定檢查範圍（批量修改只有部分欄位可編）。 */
export const findMissingRequiredFields = (data, options = {}) => {
  const src = data || {};
  const onlyKeys = options.onlyKeys;
  return PRODUCT_REQUIRED_FIELDS.filter((f) => {
    if (Array.isArray(onlyKeys) && !onlyKeys.includes(f.key)) return false;
    return !isRequiredFieldFilled(f.key, src[f.key]);
  });
};

/** 欄位下方的紅字訊息（Q4=B）。 */
export const requiredFieldMessage = (label) => `${label}為必填欄位`;
